/**
 * Component Specification Table
 *
 * @module specification-table
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "specification-table";

if (!customElements.get(customElements.component)) {
  class specificationTable extends HTMLElement {
    /**
     * Specification Table web component.
     *
     * @constructor
     */
    constructor() {
      super();

      this.metafields = window.theme.productMetafields;

      this.initEvents();
    }

    /**
     * Init module
     */
    initEvents() {
      window.addEventListener(
        "variant-change",
        this.onVariantChange.bind(this)
      );
    }

    onVariantChange(event) {
      this.metafields.productMetafields.variantMetafields.forEach(
        (variantMetafields) => {
          if (variantMetafields.variant_id == event.detail.variantId) {
            let html = this.renderSection01(variantMetafields);

            html += this.renderSection02(variantMetafields);

            html += this.renderSection03(variantMetafields);

            if (html != "") {
              this.innerHTML =
                `<div class="specification-table__content">` + html + `</div">`;
            } else {
              document
                .querySelector("[data-specification-table]")
                .classList.add("hidden");
            }
          }
        }
      );
    }

    renderSection01(variantMetafields) {
      let html = "";

      html += this.renderMetafields(
        "Collection",
        variantMetafields.collection,
        this.metafields.productMetafields.collection,
        true
      );

      html += this.renderMetafields(
        "Product Type",
        variantMetafields.type,
        this.metafields.productMetafields.type,
        true
      );

      html += this.renderMetafields(
        "Material",
        variantMetafields.material,
        this.metafields.productMetafields.material,
        true
      );

      html += this.renderMetafields(
        "Color",
        variantMetafields.color,
        this.metafields.productMetafields.color,
        true
      );

      html += this.renderMetafields(
        "Finish",
        variantMetafields.finish,
        this.metafields.productMetafields.finish,
        true
      );

      html += this.renderMetafields(
        "Drawer Front Finish",
        variantMetafields.drawer_front_finish,
        this.metafields.productMetafields.drawer_front_finish
      );

      html += this.renderMetafields(
        "Drawer Front Material",
        variantMetafields.drawer_material,
        this.metafields.productMetafields.drawer_material
      );

      html += this.renderMetafields(
        "Drawer Material",
        variantMetafields.drawer_material,
        this.metafields.productMetafields.drawer_material
      );

      html += this.renderMetafields(
        "Door Finish",
        variantMetafields.door_finish,
        this.metafields.productMetafields.door_finish
      );

      html += this.renderMetafields(
        "Door Material",
        variantMetafields.door_material,
        this.metafields.productMetafields.door_material
      );

      html += this.renderMetafields(
        "Cabinet Finish",
        variantMetafields.cabinet_finish,
        this.metafields.productMetafields.cabinet_finish
      );

      html += this.renderMetafields(
        "Cabinet Material",
        variantMetafields.cabinet_material,
        this.metafields.productMetafields.cabinet_material
      );

      html += this.renderMetafields(
        "Handle Finish",
        variantMetafields.handle_finish,
        this.metafields.productMetafields.handle_finish
      );

      html += this.renderMetafields(
        "Leg Finish",
        variantMetafields.leg_finish,
        this.metafields.productMetafields.leg_finish
      );

      html += this.renderMetafields(
        "Counter Finish",
        variantMetafields.counter_finish,
        this.metafields.productMetafields.counter_finish
      );

      html += this.renderMetafields(
        "Counter Material",
        variantMetafields.counter_material,
        this.metafields.productMetafields.counter_material
      );

      html += this.renderMetafields(
        "Lumens",
        variantMetafields.lumens,
        this.metafields.productMetafields.lumens
      );
      html += this.renderMetafields(
        "Color Temperature",
        variantMetafields.color_temperature,
        this.metafields.productMetafields.color_temperature
      );

      if (html != "") {
        html = `<div class="specification-table__grid">` + html + `</div>`;

        return `<div class="specification-table__section">` + html + `</div>`;
      } else {
        return "";
      }
    }

    renderSection02(variantMetafields) {
      let html = "";

      html += this.renderMetafields(
        "Height",
        variantMetafields.height,
        this.metafields.productMetafields.height
      );

      html += this.renderMetafields(
        "Height Beneath Desktop",
        variantMetafields.height_beneath_desktop,
        this.metafields.productMetafields.height_beneath_desktop
      );

      html += this.renderMetafields(
        "Width",
        variantMetafields.width,
        this.metafields.productMetafields.width
      );

      html += this.renderMetafields(
        "Length",
        variantMetafields.length,
        this.metafields.productMetafields.length
      );

      html += this.renderMetafields(
        "Depth",
        variantMetafields.depth,
        this.metafields.productMetafields.depth
      );

      html += this.renderMetafields(
        "Internal Height",
        variantMetafields.internal_height,
        this.metafields.productMetafields.internal_height
      );

      html += this.renderMetafields(
        "Internal Width",
        variantMetafields.internal_width,
        this.metafields.productMetafields.internal_width
      );

      html += this.renderMetafields(
        "Internal Depth",
        variantMetafields.internal_depth,
        this.metafields.productMetafields.internal_depth
      );

      html += this.renderMetafields(
        "Upper Depth",
        variantMetafields.upper_depth,
        this.metafields.productMetafields.upper_depth
      );

      html += this.renderMetafields(
        "Hanging Space",
        variantMetafields.hanging_space,
        this.metafields.productMetafields.hanging_space
      );

      html += this.renderMetafields(
        "Shelf Space",
        variantMetafields.shelf_space,
        this.metafields.productMetafields.shelf_space
      );

      html += this.renderMetafields(
        "Actual Kit Width",
        variantMetafields.actual_kit_width,
        this.metafields.productMetafields.actual_kit_width
      );

      html += this.renderMetafields(
        "Drawer Height",
        variantMetafields.drawer_height,
        this.metafields.productMetafields.drawer_height
      );

      html += this.renderMetafields(
        "Door Height",
        variantMetafields.door_height,
        this.metafields.productMetafields.door_height
      );

      html += this.renderMetafields(
        "Handle Size (center to center)",
        variantMetafields.handle_size_center_to_center,
        this.metafields.productMetafields.handle_size_center_to_center
      );

      html += this.renderMetafields(
        "Leg Height",
        variantMetafields.leg_height,
        this.metafields.productMetafields.leg_height
      );

      html += this.renderMetafields(
        "Counter Width",
        variantMetafields.counter_width,
        this.metafields.productMetafields.counter_width
      );

      html += this.renderMetafields(
        "Counter Depth",
        variantMetafields.counter_depth,
        this.metafields.productMetafields.counter_depth
      );

      html += this.renderMetafields(
        "Counter Height",
        variantMetafields.counter_height,
        this.metafields.productMetafields.counter_height
      );

      html += this.renderMetafields(
        "Base Cabinet Depth",
        variantMetafields.base_cabinet_depth,
        this.metafields.productMetafields.base_cabinet_depth
      );

      html += this.renderMetafields(
        "Upper Cabinet Depth",
        variantMetafields.upper_cabinet_depth,
        this.metafields.productMetafields.upper_cabinet_depth
      );

      html += this.renderMetafields(
        "Hamper Bag Size",
        variantMetafields.hamper_bag_size,
        this.metafields.productMetafields.hamper_bag_size
      );

      html += this.renderMetafields(
        "Diameter",
        variantMetafields.diameter,
        this.metafields.productMetafields.diameter
      );

      html += this.renderMetafields(
        "Above Bench Height",
        variantMetafields.above_bench_height,
        this.metafields.productMetafields.above_bench_height
      );

      html += this.renderMetafields(
        "Bench Height",
        variantMetafields.bench_height,
        this.metafields.productMetafields.bench_height
      );

      html += this.renderMetafields(
        "Section Width",
        variantMetafields.section_width,
        this.metafields.productMetafields.section_width
      );

      if (html != "") {
        html =
          `<div class="specification-table__title">Dimensions</div>
                <div class="specification-table__grid">` +
          html +
          `</div>`;

        return `<div class="specification-table__section">` + html + `</div>`;
      } else {
        return "";
      }
    }

    renderSection03(variantMetafields) {
      let html = "";

      html += this.renderMetafields(
        "Number of Bags",
        variantMetafields.number_of_bags,
        this.metafields.productMetafields.number_of_bags
      );

      html += this.renderMetafieldsList(
        "Fabric Care",
        (variantMetafields.fabric_care || "").split("||").join("\n"),
        (this.metafields.productMetafields.fabric_care || "").split("||").join("\n")
      );

      html += this.renderMetafields(
        "Mount Type",
        variantMetafields.mount_type,
        this.metafields.productMetafields.mount_type,
        true
      );

      html += this.renderMetafieldsTruth(
        "Clothing Rod Included",
        variantMetafields.clothing_rod_included,
        this.metafields.productMetafields.clothing_rod_included
      );

      html += this.renderMetafieldsInteger(
        "Number of Rods",
        variantMetafields.number_of_rods,
        this.metafields.productMetafields.number_of_rods
      );

      html += this.renderMetafields(
        "Rod Style",
        variantMetafields.rod_style,
        this.metafields.productMetafields.rod_style,
        true
      );

      html += this.renderMetafieldsTruth(
        "Adjustable Shelves",
        variantMetafields.adjustable_shelves,
        this.metafields.productMetafields.adjustable_shelves
      );

      html += this.renderMetafieldsInteger(
        "Number of Adjustable Shelves",
        variantMetafields.number_of_adjustable_shelves,
        this.metafields.productMetafields.number_of_adjustable_shelves
      );

      html += this.renderMetafieldsTruth(
        "Fixed Shelves",
        variantMetafields.fixed_shelves,
        this.metafields.productMetafields.fixed_shelves
      );

      html += this.renderMetafieldsInteger(
        "Number of Fixed Shelves",
        variantMetafields.number_of_fixed_shelves,
        this.metafields.productMetafields.number_of_fixed_shelves
      );

      html += this.renderMetafieldsTruth(
        "Drawers Included",
        variantMetafields.drawers_included,
        this.metafields.productMetafields.drawers_included
      );

      html += this.renderMetafieldsInteger(
        "Number of Drawers",
        variantMetafields.number_of_drawers,
        this.metafields.productMetafields.number_of_drawers
      );

      html += this.renderMetafields(
        "Shelf Weight Capacity Lbs",
        variantMetafields.shelf_weight_capacity,
        this.metafields.productMetafields.shelf_weight_capacity
      );

      html += this.renderMetafields(
        "Rod Weight Capacity",
        variantMetafields.rod_weight_capacity,
        this.metafields.productMetafields.rod_weight_capacity
      );

      html += this.renderMetafields(
        "Total Weight Capacity Lbs.",
        variantMetafields.total_weight_capacity,
        this.metafields.productMetafields.total_weight_capacity
      );

      html += this.renderMetafields(
        "Hardware Included",
        variantMetafields.hardware_included,
        this.metafields.productMetafields.hardware_included
      );

      html += this.renderMetafields(
        "Number of Legs Included",
        variantMetafields.number_of_legs_included,
        this.metafields.productMetafields.number_of_legs_included
      );

      html += this.renderMetafields(
        "Number of Handles Included",
        variantMetafields.number_of_handles_included,
        this.metafields.productMetafields.number_of_handles_included
      );

      html += this.renderMetafieldsList(
        "Kit Details",
        variantMetafields.kit_includes,
        this.metafields.productMetafields.kit_includes
      );

      html += this.renderMetafieldsTruth(
        "Has Bench",
        variantMetafields.has_bench,
        this.metafields.productMetafields.has_bench
      );

      html += this.renderMetafieldsInteger(
        "Number of Hooks",
        variantMetafields.number_of_hooks,
        this.metafields.productMetafields.number_of_hooks
      );

      html += this.renderMetafieldsInteger(
        "Hook Finish",
        variantMetafields.hook_finish,
        this.metafields.productMetafields.hook_finish
      );

      html += this.renderMetafieldsInteger(
        "Number of Sections",
        variantMetafields.number_of_sections,
        this.metafields.productMetafields.number_of_sections
      );
      
       html += this.renderMetafieldsInteger(
        "Number of Hangers Included",
        variantMetafields.number_of_hangers_included,
        this.metafields.productMetafields.number_of_hangers_included
      );




      if (html != "") {
        html =
          `<div class="specification-table__title">Item Details</div>
                <div class="specification-table__grid">` +
          html +
          `</div>`;

        return `<div class="specification-table__section">` + html + `</div>`;
      } else {
        return "";
      }
    }

    fixString(string) {
      string = string.replace(/^./, "");
      string = string.replace(/.$/, "");

      return string;
    }

    renderMetafields(name, variantValue, productValue, fix) {
      const normalize = (v) => {
        if (v == null) return ""; // catches null + undefined
        v = String(v).trim();
        if (!v || v === "null" || v === "undefined") return "";
        return fix ? this.fixString(v) : v;
      };

      const v = normalize(variantValue);
      if (v) {
        return `
      <div class="specification-table__grid-item">
        <div class="specification-table__name">${name}</div>
        <div class="specification-table__value">${v}</div>
      </div>`;
      }

      const p = normalize(productValue);
      if (p) {
        return `
      <div class="specification-table__grid-item">
        <div class="specification-table__name">${name}</div>
        <div class="specification-table__value">${p}</div>
      </div>`;
      }

      return "";
    }


    renderMetafieldsList(name, variantValue, productValue, fix) {
      variantValue = variantValue || "";
      productValue = productValue || "";

      const listVariant = variantValue.split('\n');
      const listProdcut = productValue.split('\n');

      if (variantValue != "" && variantValue != "null") {
        if (fix) {
          variantValue = this.fixString(variantValue);
        }
        return (
          `<div class="specification-table__grid-item">
             <div class="specification-table__name">${name}</div>
             <ul class="specification-table__value specification-table__list">
              ${listVariant.map(item => `<li>${item}</li>`).join('')}
             </ul>
           </div>
        `);
      } else if (productValue != "" && productValue != "null") {
        if (fix) {
          productValue = this.fixString(productValue);
        }
        return (
          `<div class="specification-table__grid-item">
             <div class="specification-table__name">${name}</div>
             <ul class="specification-table__value specification-table__list">
              ${listProdcut.map(item => `<li>${item}</li>`).join('')}
             </ul>
           </div>
        `);
      } else {
        return "";
      }
    }

    renderMetafieldsTruth(name, variantValue, productValue) {
      variantValue = variantValue.replace("true", "Yes");
      variantValue = variantValue.replace("false", "No");

      productValue = productValue.replace("true", "Yes");
      productValue = productValue.replace("false", "No");

      return this.renderMetafields(name, variantValue, productValue);
    }

    renderMetafieldsInteger(name, variantValue, productValue) {
      if (variantValue == "0") {
        variantValue = "N/A";
      }

      if (productValue == "0") {
        productValue = "N/A";
      }

      return this.renderMetafields(name, variantValue, productValue);
    }
  }

  customElements.define(customElements.component, specificationTable);
}
